import { render, staticRenderFns } from "./AddSingleProductDashboard.vue?vue&type=template&id=69c8b414&scoped=true&"
import script from "./AddSingleProductDashboard.vue?vue&type=script&lang=js&"
export * from "./AddSingleProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AddSingleProductDashboard.vue?vue&type=style&index=0&id=69c8b414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8b414",
  null
  
)

export default component.exports